import React, {Component} from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Layout
import Header from "../layout/header";
import Footer from "../layout/footer";
import bg2Import from "../../images/background/bg1.png";

// Elements
import AboutUsTwoSection from "../elements/about-us-2";
import ServicesSection from "../elements/services-1";
import ScheduleServiceSection from "../elements/schedule-service";
import PricingTableSection from "../elements/pricing-table";
import TestimonialSection from "../elements/testimonial";
import LatestBlogSection from "../elements/latest-blog-slider";
import AvailableCitiesModal from '../elements/available-cities-modal';

// Images
import bnrImgImport from "../../images/banner/img_aboutbnr.webp";

const bg2 = typeof bg2Import === 'object' ? bg2Import.default : bg2Import;
const bnrImg = typeof bnrImgImport === 'object' ? bnrImgImport.default : bnrImgImport;

class CancellationPolicy extends Component{

	state = {
    isClient: false,
  };

	componentDidMount() {
		this.setState({ isClient: true });
	}
	
	render(){

		const { isClient } = this.state;

		return (
			<>
				<Helmet>
					<title>Cancellation Policy | Ride N Repair</title>
					<meta name="description" content="Ride N Repair cancellation policy. Cancel your booking any time — free until our mechanic reaches you. A Rs 399 visit charge applies once the mechanic has reached your location." />
					<link rel="canonical" href="https://www.ridenrepair.com/cancellation-policy" />
				</Helmet>
				{this.props.citiesModal && <AvailableCitiesModal closeModal={() => this.props.setCitiesModal(false)} />}

				<Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />

				<div className="page-content bg-white">
					
					<div className="page-banner ovbl-dark" style={ isClient ? { backgroundImage: "url("+bnrImg+")" } : {} }>
						<div className="container">
							<div className="page-banner-entry text-center">
								<h1><span>Cancellation Policy</span></h1>
								<nav aria-label="breadcrumb" className="breadcrumb-row">
									<ul className="breadcrumb">
										<li className="breadcrumb-item"><Link to="/"><i className="las la-home"></i>Home</Link></li>
										<li className="breadcrumb-item active" aria-current="page">Cancellation Policy</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
					
					<section className="section-area section-sp1 bg-white" style={ isClient ? { backgroundImage: "url("+bg2+")", backgroundRepeat: "no-repeat" } : {} }>
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6 mb-30 mb-md-50">
								<div className="heading-bx">
									<h4 className="title-ext text-primary">Cancellation Policy</h4>
									<p>At RIDE N REPAIR, we understand that plans can change. You can cancel your booking at any time — there is no cancellation fee.</p>
									<p><b>Free cancellation:</b> Cancelling before our mechanic reaches your location is free. If you paid online, the full amount is refunded.</p>
									<p><b>Visit charge:</b> Once our mechanic has reached your location, a visit charge of Rs 399 applies, whether or not you go ahead with the service. This also applies if the mechanic reaches the booked location and you are unavailable.</p>
									<p><b>Rescheduling:</b> You can reschedule your booking free of charge from the app or by contacting us.</p>
									<p><b>Contact:</b> For questions about this Cancellation Policy or to cancel a booking, please contact us at +911203615050 or info@ridenrepair.com</p>
									<p>This Cancellation Policy is effective as of 20 Oct 2026.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				
				</div>
				
				<Footer setCitiesModal={this.props.setCitiesModal} />
				
			</>
		);
	}
}

export default CancellationPolicy;